import { lazyLoad } from '@react-page/editor';
import createPlugin from './createPlugin';
import ButtonHtmlRenderer from './Renderer/ButtonHtmlRenderer';
const ButtonControls = lazyLoad(() => import('./Controls/ButtonControls'));
const buttonPlugin = (settings) => createPlugin(Object.assign({ Renderer: ButtonHtmlRenderer, Controls: ButtonControls }, settings));
const button = buttonPlugin();
export default button;
export { buttonPlugin };
//# sourceMappingURL=index.js.map